import React, { useState, useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiClose, mdiAlert } from "@mdi/js";
import { pushNotification } from "utils/notifications";
import {
  getListDanhSachDonDatHang,
  updateDataSearch,
} from "../../../../../actions/DanhSachDonDatHang";
import numeral from "numeral";
import { CustomerParseFloat } from "utils/currencyFormat";
import { getUserLogin } from "utils/utils";
import BanHangApi from "service/BanHangService/BanHangApi";
import { CloseModal } from "utils/utils";
import { getBranch } from "utils/utils";
export const ModalThongBaoSua = ({ CloseModalSua, item }) => {
  console.log(item, "111111");
  const dispatch = useDispatch();
  useEffect(() => {
    debugger;
    // T?o listener v?i CloseModalXoa
    const escListener = CloseModal(CloseModalSua);

    // Thêm listener khi component mount
    escListener.addListener();

    // G? listener khi component unmount
    return () => {
      escListener.removeListener();
    };
  }, [CloseModal]); // Ch? thêm l?i effect n?u handleClose thay d?i

  const init = {
    OrderID: item.OrderID,
    Note: "",
    sUserName: getUserLogin().UserName,
  };
  const [dataCheckYC, setDataCheckYC] = useState(init);

  const onChangeText = (field, e) => updateStateThongTin(field, e);
  const updateStateThongTin = (field, e) => {
    const thongtin = { ...dataCheckYC };
    const value = e.target.validity.valid ? e.target.value : thongtin[field];
    thongtin[field] = value;
    setDataCheckYC(thongtin);
  };

  useEffect(() => {
    document.addEventListener(
      "keydown",
      (e) => {
        escFunction(e);
      },
      false
    );
  }, []);

  useLayoutEffect(() => {
    document.removeEventListener(
      "keydown",
      (e) => {
        escFunction(e);
      },
      false
    );
  }, []);

  const escFunction = (event) => {
    if (event.key === "Escape") {
      CloseModal();
    }
  };
  const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);

  const [doubleClick, setDoubleClick] = useState(false);
  const onSubmit = () => {
    if (getBranch() == 0 || getBranch() == "0") {
      pushNotification("Vui lòng chọn chi nhánh", "error", "TOP_RIGHT", 2000);
      return;
    }
    if (dataCheckYC.Note === "") {
      pushNotification(
        "Bạn chưa nhập lý do duyệt đơn hàng!",
        "error",
        "TOP_RIGHT",
        2000
      );
      return;
    }

    setDoubleClick(true);
    BanHangApi.addYeuCauChoDuyet(
      dataCheckYC.OrderID,
      dataCheckYC.Note,
      dataCheckYC.sUserName
    ).then((response) => {
      if (response.status === 200) {
        CloseModal();
        pushNotification(
          "Gửi yêu cầu xét duyệt thành công",
          "success",
          "TOP_RIGHT",
          2000
        );
        dispatch(getListDanhSachDonDatHang(dataSearch));
      } else {
        setDoubleClick(false);
        pushNotification(response.data, "error", "TOP_RIGHT", 2000);
      }
    });
  };
  return (
    <>
      <div className="popup ">
        <div class="popup_inner " style={{ maxWidth: "500px" }}>
          <div class="modal-content form-modal-new">
            <div class="modal-header">
              <h4
                class="modal-title"
                id="myLargeModalLabel"
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  lineHeight: "24px",
                }}
              >
                <div class="bgIconTitle">
                  <Icon path={mdiAlert} title="" color="#fff" size={1.5} />
                </div>
                Yêu cầu xét duyệt cho phép sửa đơn hàng: {item.OrderCode}
              </h4>
              <button
                type="button"
                class="close"
                onClick={CloseModal}
                aria-label="Close"
              >
                <Icon path={mdiClose} title="In" size={1.5} color="#ccc" />
              </button>
            </div>
            <div class="modal-body text-left-main">
              {item.DuyetNote !== "" ? (
                <span style={{ color: "red" }}>
                  Đơn hàng {item.OrderCode} đã gửi yêu cầu duyệt chỉnh sửa. Vui
                  lòng liên hệ với quản lý để được xét duyệt.
                </span>
              ) : (
                <>
                  <span style={{ color: "red" }}>
                    Đơn hàng {item.OrderCode} đã quá hạn thời gian được phép
                    chỉnh sửa. Vui lòng gửi yêu cầu lên quản lý cửa hàng để được
                    xét duyệt sửa
                  </span>
                  <div class=" form-group  mb-3" style={{ marginTop: "15px" }}>
                    <label class="text-label-new">
                      Lý do cần sửa đơn hàng{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      class="form-control text-left"
                      id="idGhiChu"
                      value={dataCheckYC.Note}
                      onChange={(e) => onChangeText("Note", e)}
                      rows="3"
                      cols="20"
                    ></textarea>
                  </div>
                </>
              )}
            </div>
            <div class="modal-footer">
              <div class="footer-search-main">
                <button
                  type="submit"
                  class="text-button-search mr-2"
                  onClick={CloseModal}
                >
                  Huỷ bỏ
                </button>
                {item.DuyetNote !== "" ? null : (
                  <button
                    class="button-Add-NoIcon bg-blue-main"
                    onClick={onSubmit}
                    disabled={doubleClick}
                  >
                    Gửi yêu cầu
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
